import { useDispatch as baseUseDispatch } from 'react-redux';
import { Action, GlobalState, ThunkDispatch } from 'types';

export { default as useForm } from './useForm';
export { default as useTitle } from './useTitle';

export const useDispatch = baseUseDispatch<ThunkDispatch<GlobalState, unknown, Action>>;
